export default __webpack_public_path__ + "static/media/comfortaa-light-webfont.9696f372.woff2";